import { Injectable } from '@angular/core';

import { XpoLtlAuthenticationService } from '@xpo-ltl/ngx-auth';
import { Observable, of } from 'rxjs';

/**
 * Auth service that prevents logout
 */
@Injectable()
export class XpoLtlAuthenticationServiceNoLogout extends XpoLtlAuthenticationService {
  isAuthorized(): Observable<boolean> {
    return of(true);
  }

  logout() {
    console.log('CYPRESS TESTING - Disable Logout');
  }
}
